import React, { useEffect, useState } from "react";
import axios from "axios";
import URL from "../config/API";
import { useLocation } from "react-router-dom";

function Product({keyword}) {
    console.log("✅ Product page loaded");

    const [products, setProducts] = useState([]);
    const location = useLocation();

    // const searchParams = new URLSearchParams(location.search);
    // const keyword = searchParams.get("search");

    console.log("🔍 Search keyword:", keyword);

    useEffect(() => {
        if (keyword) {
            axios
                .get(`${URL.BASE_URL}/products/search?keyword=${keyword}`)
                .then(res => {
                    console.log("✅ API response:", res.data);
                    setProducts(res.data.data);
                })
                .catch(err => {
                    console.error("❌ Search error:", err);
                });
        } else {
            axios.get(`${URL.BASE_URL}/products`)
                .then(res => setProducts(res.data.data));
        }
    }, [keyword]);

    return (
        <div className="container">
            <h3>
                {keyword ? `Search results for "${keyword}"` : "All Products"}
            </h3>

            <div className="row">
                {products.length > 0 ? (
                    products.map(product => (
                        <div className="col-lg-3" key={product.id}>
                            <div className="product-card">
                                <h5>{product.product_name}</h5>
                                <p>₹{product.product_price}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No products found</p>
                )}
            </div>
        </div>
    );
}

export default Product;
